import React from "react";
import ReactHtmlParser from "react-html-parser";
import { useLocation } from "react-router-dom";

const Portfolio = () => {
  window.scrollTo(0, 0);
  const location = useLocation();
  const {
    title,
    description,
    name,
    imageUrlDesc,
    imageUrl2,
    imageWidth,
    imageHeight,
    imageUrlSide,
  } = location.state.image;

  return (
    <div className="w-full bg-white py-16 px-4">
      <div className="max-w-[1240px] mx-auto flex justify-center">
        {/* <img className="w-[300px] mx-auto my-4" src={Laptop} alt="/" /> */}
        <div className="flex flex-col justify-center ">
          <p className="text-[#00df9a] font-bold ">{title.toUpperCase()}</p>
          <h1 className="md:text-4xl sm:text-3xl text-2xl font-bold py-10">
            {name}
          </h1>
          <div>
            <div className="flex flex-wrap">
              <div className="sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
                {ReactHtmlParser(description)}
              </div>
              {imageUrlSide && (
                <img
                  className="lg:-mt-24 xl:-mt-24 sm:w-full md:w-full lg:w-1/2 xl:w-1/2"
                  src={imageUrlSide}
                  alt={title}
                  width="800px"
                />
              )}
            </div>
            <div
              className={`flex flex-wrap mx-32 ${
                imageUrl2 ? "lg:justify-between xl:justify-between" : ""
              }`}
            >
              {imageUrl2 ? (
                <img
                  src={imageUrl2}
                  alt={name}
                  className="sm:w-32 md:w-32 lg:w-1/3 xl:w-1/3"
                />
              ) : (
                ""
              )}
              <img
                className="sm:w-32 md:w-32 lg:w-1/3 xl:w-1/3"
                src={imageUrlDesc}
                alt={title}
                width={imageWidth}
                height={imageHeight}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
